import * as React from 'react';

import { SelectFormGroup, SelectFormGroupProps } from '@admin/components/fields/select_form_group';
import { client } from '@admin/libraries/apollo';
import { useRegionsSelectorQuery, type Region } from '@admin/schema';

export type RegionSelectFormGroupProps = Omit<SelectFormGroupProps, 'children' | 'value' | 'onChange'> & {
  value?: string;
  onChange(value?: Region['id']): void;
};

export const RegionSelectFormGroup: React.FC<RegionSelectFormGroupProps> = ({
  disabled,
  value,
  onChange,
  ...props
}) => {
  const { data, loading } = useRegionsSelectorQuery({ client });
  const regions = data?.regions ?? [];

  return (
    <SelectFormGroup
      disabled={disabled || loading}
      {...props}
      value={value ?? ''}
      onChange={(event) => onChange((event.target.value || undefined) as Region['id'] | undefined)}
    >
      <option value="">- Region -</option>
      {regions.map((region) => (
        <option key={region.id} value={region.id}>
          {region.name}
        </option>
      ))}
    </SelectFormGroup>
  );
};
